import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=2e41c7be&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style0 from "./swiper.vue?vue&type=style&index=0&id=2e41c7be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41c7be",
  null
  
)

export default component.exports